import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ProjectId, TaskId } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { deleteTask, saveTasks } from 'data/tasks/slice';
import { withValidCustomFieldsForData } from 'utils/duplicate-fields-transformer';
import { debouncedFetchTaskSaga } from '../use-debounced-fetch-task';
import { useProjectWSUpdates } from '../use-project-ws-updates';

export const useProjectTaskWebsocket = ([, projectId]: ProjectId): void => {
  const dispatch = useDispatch();
  const handleTaskSocketUpdate = useCallback(
    async (socketData) => {
      const { data } = socketData;

      switch (socketData.action) {
        case Action.Duplicate:
          socketData.data.forEach(async (item) => {
            const task = await TaskAPI.getTask(socketData.projectId, item);
            const updatedTask = {
              ...task,
              fields: task.fields.map(withValidCustomFieldsForData),
            };

            dispatch(
              saveTasks({
                data: [updatedTask],
                fetchStatus: FetchStatus.Loaded,
              }),
            );
          });
          break;
        case Action.Create:
        case Action.Update:
          debouncedFetchTaskSaga(
            TaskId(socketData.projectId, data.taskId),
            dispatch,
          );
          break;

        case Action.Delete:
          dispatch(deleteTask(TaskId(socketData.projectId, data.taskId)));
          break;

        default:
      }
    },
    [dispatch],
  );

  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Update, ObjectType.Task),
  );

  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Create, ObjectType.Task),
  );

  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Delete, ObjectType.Task),
  );
  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Duplicate, ObjectType.Task),
  );
};
